export const ParceirosSolar = [
  {
    state: 'Acre',
    parceiros: [
      {
        nameParceiro: 'LUMUS SOLAR',
        cnpj: '27.440.997/0001-57',
        endereco: 'AVENIDA ANTNIO DA ROCHA VIANA- VILAGE WILDE MACIEL',
        url: 'https://www.instagram.com/lumus_solar/',
      },
      {
        nameParceiro: 'ECOPOWER',
        cnpj: '182.698.15/0001-36',
        endereco: 'R DELMIRO JOSE DE ANDRADE 607',
        url: 'https://ecopower.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Alagoas',
    parceiros: [
      {
        nameParceiro: 'D SOLARE ENERGIA',
        cnpj: '25.003.808/0001-53',
        endereco: 'AV DOUTOR JULIO MARQUES LUZ 99',
        url: 'https://dsolare.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1841',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
      {
        nameParceiro: 'GRUPO VIRTRON',
        cnpj: '31.142.624/0001-77',
        endereco: 'RUA LIMA E SILVA 29 GALPAO A - CARUARU',
        url: 'https://linktr.ee/virtronenergiasolar',
      },
    ],
  },
  {
    state: 'Amazonas',
    parceiros: [
      {
        nameParceiro: 'CRITERIA ENERGIA SOLAR',
        cnpj: '31.595.602/0001-62',
        endereco: 'TV URBANO NOVO 165 - CHAPADA  ',
        url: 'https://criteriaenergia.com.br/',
      },
      {
        nameParceiro: 'SOLALUX COMER DE PROD DE ILUMINAC LTDA',
        cnpj: '13.778.863/0001-36',
        endereco: 'RUA MACEIO 27 - NOSSA SRA DAS GRAÇAS ',
        url: 'https://www.solalux.com.br',
      },
      {
        nameParceiro: 'ECOPOWER',
        cnpj: '18.269.815/0001-36',
        endereco: 'RUA DELMIRO JOSE DE ANDRADE 606',
        url: 'https://ecopower.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Amapa',
    parceiros: [
      {
        nameParceiro: 'C2 PAINEIS FOTOVOLTAICOS LTDA',
        cnpj: '31.412.870/0001-00',
        endereco: 'ROD DE DUCA SERRA - MARABAIXO',
        url: 'https://www.instagram.com/c2energiasolaroficial',
      },
      {
        nameParceiro: 'ECOPOWER',
        cnpj: '18.269.815/0001-36',
        endereco: 'R DELMIRO JOSE DE ANDRADE 605',
        url: 'https://ecopower.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Bahia',
    parceiros: [
      {
        nameParceiro: 'GAUSS',
        cnpj: '25.043.896/0001-17',
        endereco: 'R BARRO VERMELHO 32',
        url: 'http://www.gaussenergia.com.br/',
      },
      {
        nameParceiro: 'ECOPOWER',
        cnpj: '18.269.815/0001-36',
        endereco: 'R DELMIRO JOSE DE ANDRADE 604',
        url: 'https://ecopower.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1842',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Ceara',
    parceiros: [
      {
        nameParceiro: '55 ENERGY',
        cnpj: '49.016.616/0001-40',
        endereco: 'AV DR JOSE A MONTE E SILVA 830',
        url: 'https://linktr.ee/55energy',
      },
      {
        nameParceiro: 'GLOBAL GRID ENERGY',
        cnpj: '41.364.759/0001-30',
        endereco: 'AV HUMBERTO MONTE 2929 SL 708',
        url: 'https://linktr.ee/globalgridenergy',
      },
      {
        nameParceiro: 'AGILIS SOLAR',
        cnpj: '19.300.059/0001-23',
        endereco: 'RUA GENERAL PIRAGIBE 239',
        url: 'https://linktr.ee/agilissolar',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1843',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Distrito Federal',
    parceiros: [
      {
        nameParceiro: 'ECOINTEL',
        cnpj: '47.968.226/0001-44',
        endereco: 'ST SCS 22 QUADRA02 BLOCO C EDIF SERRA DOURADA SALA 609',
        url: 'https://www.instagram.com/ecointelenergia?igsh=MW16Z2M5Y3Vyeng0ZA==',
      },
      {
        nameParceiro: 'ECOPOWER',
        cnpj: '18.269.815/0001-36',
        endereco: 'R DELMIRO JOSE DE ANDRADE 603',
        url: 'https://ecopower.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Espirito Santo',
    parceiros: [
      {
        nameParceiro: 'ELETROSUN',
        cnpj: '26.070.917/0001-56',
        endereco: 'AV CARLOS LINDENBERG 2416',
        url: 'https://www.instagram.com/eletrosun?igsh=a3J1emNrdHgzZXZz',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Goias',
    parceiros: [
      {
        nameParceiro: 'BRUKY ENERGIA',
        cnpj: '59.362.720/001-11',
        endereco: 'AV VERIANO DE OLIVEIRA LIMA 850',
        url: 'https://www.instagram.com/brukyenergy?igsh=MW14MWx5dmpwYTZobw==',
      },
      {
        nameParceiro: 'SOLAR INVESTIMENTOS LTDA',
        cnpj: '44.694.907/0001-73',
        endereco: 'R FORTUNATO DE CASTRO SN',
        url: 'https://www.instagram.com/solar.investimentos?igsh=MWIxdWN2OG03b2V3bg==',
      },
      {
        nameParceiro: 'MHZ SOLUCOES',
        cnpj: '28.664.003/0001-49',
        endereco: 'RUA PAULINA LUIS N 76 QD 05 LT 06 - VILA SANTA RITA',
        url: 'https://www.instagram.com/mhzenergiasolar?igsh=M210dnpubzRtbnRy',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Maranhão',
    parceiros: [
      {
        nameParceiro: 'ECOPOWER',
        cnpj: '18.269.815/0001-36',
        endereco: 'R DELMIRO JOSE DE ANDRADE 602',
        url: 'https://ecopower.com.br/',
      },
      {
        nameParceiro: 'ELETROCLIMA ENERGIA SOLAR',
        cnpj: '17.345.344/0001-35',
        endereco: 'AV RIO BRANCO, 1220 CENTRO',
        url: 'https://www.instagram.com/eletroclimaenergia?igsh=b2hxc2xtaWRoazFk',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1844',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Minas Gerais',
    parceiros: [
      {
        nameParceiro: 'PASSOS ENERGIA SOLAR',
        cnpj: '35.562.221/0001-38',
        endereco: 'R DOIS DE NOVEMBRO 303',
        url: 'https://www.instagram.com/passosenergiasolar?igsh=ZXlqNDF2aDY2MHIy',
      },
      {
        nameParceiro: 'TRIADE ENERGI',
        cnpj: '39.426.610/0001-97',
        endereco: 'AV CAP MANOEL PRATA 61',
        url: 'https://www.instagram.com/triadeenergia.mg?igsh=MXF5YWpoOWk0aWZzYQ==',
      },
      {
        nameParceiro: 'ELETROBIDU',
        cnpj: '00.762.527/0001-53', // Pesquisei e achei esse, porém na planilah está com 12 números: 762527000153
        endereco: 'EST BENEDITO RODRIGUES CARDOSO',
        url: 'https://www.eletrobidu.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'AV ADVOGADO H R FILHO 1848 - MARINGA',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Mato Grosso do Sul',
    parceiros: [
      {
        nameParceiro: 'GRUPO R SOLAR',
        cnpj: '24.032.392/0001-39',
        endereco: 'AV. CONSUL ASSAF TRAD, 2175, BAIRRO: CORONEL ANTONINO',
        url: 'https://wa.me/5567993231065',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Mato Grosso',
    parceiros: [
      {
        nameParceiro: 'MEGLIOSOLE ENERGIA RENOVAVEL LTDA',
        cnpj: '26.646.540/0001-30',
        endereco: 'AV IPIRANGA 1715 SALA 04 - PORTO',
        url: 'https://www.instagram.com/megliosole/',
      },
      {
        nameParceiro: 'AMPLI ENGENHARIA E FOTOVOLTAICO LTDA',
        cnpj: '44.862.708/0001-27',
        endereco: 'AV PREF MURILO DOMINGOS 825 - CRISTO REI',
        url: 'https://www.instagram.com/ampliengenharia/',
      },
      {
        nameParceiro: 'SOLIT ENERGIA S',
        cnpj: '24.950.144/0001-77',
        endereco: 'AV BANDEIRANTES 4687 - LOTEAMENTO ESPLANADA',
        url: 'https://www.solitbrasil.com.br',
      },
      {
        nameParceiro: 'SOLTURI SOLAR',
        cnpj: '31.087.724/0001-48',
        endereco: 'Av. Mal. Deodoro da Fonseca, 1560 - Centro, Jaraguá do Sul - SC, 89251-702',
        url: 'https://solturi.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Pará',
    parceiros: [
      {
        nameParceiro: 'FACILL ENERGIA',
        cnpj: '28.037.247/0001-00',
        endereco: 'AV TAPAJOS 2061 - ALDEIA',
        url: 'https://www.instagram.com/facillenergiasolar/',
      },
      {
        nameParceiro: 'SANISU ENERGIA',
        cnpj: '39.295.967/0001-83',
        endereco: 'TV WE 23 382 - CIDADE NOVA',
        url: 'https://www.instagram.com/sanisuenergiasolar/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Paraíba',
    parceiros: [
      {
        nameParceiro: 'S4 MAIS',
        cnpj: '31.963.174/0001-83',
        endereco: 'RUA BANANEIRAS 361',
        url: 'https://www.s4m.com.br',
      },
      {
        nameParceiro: 'TECCEL ENERGIA',
        cnpj: '14.237.493/0001-92',
        endereco: 'RUA PROJETADA SN',
        url: 'https://linktr.ee/teccel_energiasolar',
      },
      {
        nameParceiro: 'SOLAR NASCENTE',
        cnpj: '32.316.842/0001-43',
        endereco: 'RUA PROJETADA 24',
        url: 'https://share.google/WFZzSFjywG2SyfC91',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1845',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
      {
        nameParceiro: 'GRUPO VIRTRON',
        cnpj: '31.142.624/0001-77',
        endereco: 'RUA LIMA E SILVA 29 GALPAO A - CARUARU',
        url: 'https://linktr.ee/virtronenergiasolar',
      },
    ],
  },
  {
    state: 'Pernambuco',
    parceiros: [
      {
        nameParceiro: 'GRUPO VIRTRON',
        cnpj: '31.142.624/0001-77',
        endereco: 'RUA LIMA E SILVA 29 GALPAO A',
        url: 'https://linktr.ee/virtronenergiasolar',
      },
      {
        nameParceiro: 'NAÇÃO SOLAR',
        cnpj: '60.198.038/0001-42',
        endereco: 'AV JOAO GOMES DE LUCENA 2558',
        url: 'https://linktr.ee/NACAOSOLAR',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1846',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Piauí',
    parceiros: [
      {
        nameParceiro: 'ELETROCLIMA ENERGIA SOLAR',
        cnpj: '17.345.344/0001-35',
        endereco: 'AV RIO BRANCO, 1220 CENTRO',
        url: 'https://www.instagram.com/eletroclimaenergia?igsh=b2hxc2xtaWRoazFk',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1847',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Paraná',
    parceiros: [
      {
        nameParceiro: 'SOLARLUX',
        cnpj: '41.795.040/0001-54',
        endereco: 'R PIONEIRO ANTONIO BERNARDES, 220 SL03',
        url: 'https://www.instagram.com/solarluxenergiasolar?igsh=MTI4a2dwMDk1ZGVzcQ==',
      },
      {
        nameParceiro: 'SOLAR TECHNOLOGY',
        cnpj: '32.930.045/0001-51',
        endereco: 'AV MARACANA 3530',
        url: 'https://www.instagram.com/solartechnologyarapongas/',
      },
      {
        nameParceiro: 'HB SOLAR',
        cnpj: '25.152.571/0001-72',
        endereco: 'R CELSO GARCIA CID,1743',
        url: 'https://www.hbenergiasolar.com.br',
      },
      {
        nameParceiro: 'ELETROBIDU',
        cnpj: '76.25270001-53', // ESTA FALTANDO
        endereco: 'EST BENEDITO RODRIGUES CARDOSO',
        url: 'https://www.eletrobidu.com.br/',
      },
      {
        nameParceiro: 'SOLTURI SOLAR',
        cnpj: '31.087.724/0001-48',
        endereco: 'Av. Mal. Deodoro da Fonseca, 1560 - Centro, Jaraguá do Sul - SC, 89251-702',
        url: 'https://solturi.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1836',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Rio de Janeiro',
    parceiros: [
      {
        nameParceiro: 'ECOPOWER',
        cnpj: '18.269.815/0001-36',
        endereco: 'R DELMIRO JOSE DE ANDRADE 607',
        url: 'https://ecopower.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'AV ADVOGADO H R FILHO 1848 - MARINGA',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Rio Grande do Norte',
    parceiros: [
      {
        nameParceiro: 'INTERSOLIS',
        cnpj: '19.213.193/0001-97',
        endereco: 'RUA MACEIO 4117',
        url: 'https://linktr.ee/intersolis',
      },
      {
        nameParceiro: 'POTISOL',
        cnpj: '32.225.090/0001-05',
        endereco: 'RUA CHICO PEDRO 2',
        url: 'https://bento.me/potisolenergia',
      },
      {
        nameParceiro: 'GRUPO KAIO CESAR',
        cnpj: '33.558.700/0001-55',
        endereco: 'AV CANDIDO DANTAS DE ARAUJO 63',
        url: 'https://bit.ly/4p378vf',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1848',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Rondônia',
    parceiros: [
      {
        nameParceiro: 'ENBRASSOL',
        cnpj: '36.293.232/0001-22',
        endereco: 'AV CANAA 2621 - SETOR 03',
        url: 'https://enbrassol.com.br/',
      },
      {
        nameParceiro: 'SOLAR ELETRICID',
        cnpj: '41.686.912/0001-46',
        endereco: 'R JOSE VIEIRA CAULA 6441 - ESPERANCA COMUNIDADE',
        url: 'https://www.instagram.com/ea_eletroalves/',
      },
      {
        nameParceiro: 'IMPACTO ENERGIA',
        cnpj: '30.488.181/0001-08',
        endereco: 'AV AVN D PEDRO I 3227 SALA B - SETOR 05',
        url: 'https://impactosolarenerg.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Roraima',
    parceiros: [
      {
        nameParceiro: 'SUSTENTAVEL ENERGIA SOLAR LTDA',
        cnpj: '43.385.410/0001-00',
        endereco: 'AV SANTOS DUMONT 781 - SAO PEDRO',
        url: 'https://www.instagram.com/sustentavel_energiarr/',
      },
      {
        nameParceiro: 'TECHFRIO E M I E COMERCIO LTDA',
        cnpj: '14.191.074/0001-67',
        endereco: 'AV MARIO HOMEM DE MELO3841',
        url: 'https://www.instagram.com/techfriobr/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Rio Grande do Sul',
    parceiros: [
      {
        nameParceiro: 'SOLTURI SOLAR',
        cnpj: '31.087.724/0001-48',
        endereco: 'Av. Mal. Deodoro da Fonseca, 1560 - Centro, Jaraguá do Sul - SC, 89251-702',
        url: 'https://solturi.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
      {
        nameParceiro: 'MGF ENGENHARIA E ENERGIA',
        cnpj: '26.617.916/0001-89',
        endereco: 'Av. DR. SEZEFREDO AZAMBUJA VIEIRA, 2481',
        url: 'https://wa.me/555192333358?text=Ol%C3%A1%2C%20quero%20saber%20mais%20sobre%20as%20solu%C3%A7%C3%B5es%20da%20MGF',
      },
      {
        nameParceiro: 'SOLLED',
        cnpj: '37.527.09/0001-31',
        endereco: 'ROD RST 287 SN KM 101',
        url: 'https://solledenergia.com.br/',
      },
    ],
  },
  {
    state: 'Santa Catarina',
    parceiros: [
      {
        nameParceiro: 'SOLAR VALE',
        cnpj: '22.102.302/0001-03',
        endereco: 'VIA EXPRESSA, ROD PAUL FRITZ KUEHNRICH 1515',
        url: 'https://solarvale.com.br/',
      },
      {
        nameParceiro: 'TOPSUN',
        cnpj: '27.494.036/0001-25',
        endereco: 'RUA FRITZ BARTEL 200',
        url: 'https://topsun.com.br/',
      },
      {
        nameParceiro: 'SOLTURI SOLAR',
        cnpj: '31.087.724/0001-48',
        endereco: 'Av. Mal. Deodoro da Fonseca, 1560 - Centro, Jaraguá do Sul - SC, 89251-702',
        url: 'https://solturi.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1840',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Sergipe',
    parceiros: [
      {
        nameParceiro: 'PRO SOLAR SE',
        cnpj: '24.361.095/0001-37',
        endereco: 'AV SAO JOAO BATISTA 548',
        url: 'https://probrasilenergia.com.br',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1849',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'São Paulo Capital e Metropolitana',
    parceiros: [
      {
        nameParceiro: 'ANTONIO SOLAR',
        cnpj: '35.138.921/0001-08',
        endereco: 'RUA 23 DE MAIO 581 - NOSSA SENHORA DE LOURDES',
        url: 'https://www.instagram.com/engenhariasolarasa?igsh=MXVibHZ2cWZlZTcwdA==',
      },
      {
        nameParceiro: 'SOLAR DEZ',
        cnpj: '10.247.083/0001-71',
        endereco: 'RUA 11 DE AGOSTO 2332 - JD LUCILA',
        url: 'https://solardez.com.br/contato',
      },
      {
        nameParceiro: 'FACILITE SOLAR',
        cnpj: '58.002.150/0001-14',
        endereco: 'AV ITALIA 1000',
        url: 'https://www.facilitesolar.com.br/',
      },
      {
        nameParceiro: 'ECOPOWER',
        cnpj: '18.269.815/0001-36',
        endereco: 'R DELMIRO JOSE DE ANDRADE 607',
        url: 'https://ecopower.com.br/',
      },
      {
        nameParceiro: 'ELETROBIDU',
        cnpj: '76.2527/0001-53', // ESTA FALTANDO
        endereco: 'EST BENEDITO RODRIGUES CARDOSO',
        url: 'https://www.eletrobidu.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1838',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'São Paulo Interior',
    parceiros: [
      {
        nameParceiro: 'SOLLART ENERGIA SOLAR',
        cnpj: '37.256.731/0001-02',
        endereco: 'R MIGUEL PETRONI 1275',
        url: 'https://www.instagram.com/sollart.energia/',
      },
      {
        nameParceiro: 'CAPACITECH',
        cnpj: '15.353.977/0001-60',
        endereco: 'R PROF REGINA LUCIA BIN CAUN 266',
        url: 'https://www.instagram.com/capacitechenergia?igsh=ZmI5aW02eWZxY2Vp',
      },
      {
        nameParceiro: 'SOLENERGY',
        cnpj: '18.343.978/0001-11',
        endereco: 'R JOAO PESSOA 827',
        url: 'https://www.instagram.com/solenergybr/',
      },
      {
        nameParceiro: 'SEC URUPES',
        cnpj: '29.141.142/0001-50',
        endereco: 'AV. DEP. ANTÔNIO DE PÁDUA PEROSA, 297, URUPÊS-SP / CEP: 15850-250',
        url: 'https://www.instagram.com/secenergiasolar/',
      },
      {
        nameParceiro: 'SEC RIO PRETO',
        cnpj: '29.141.142/0001-50',
        endereco: 'RUA NAJLA ELIANI CHADDAD, 6930, SALA 12, JARDIM DAS VIVENDAS, CEP: 15085-894',
        url: 'https://www.secenergiasolar.com.br',
      },
      {
        nameParceiro: 'MIDRA',
        cnpj: '29.735.224/0001-23',
        endereco: 'R JOAQUIM NABUCO 28, BAIRRO: BASSAN',
        url: 'https://www.instagram.com/MIDRADISTRIBUIDORA',
      },
      {
        nameParceiro: 'ECOPOWER',
        cnpj: '18.269.815/0001-36',
        endereco: 'R DELMIRO JOSE DE ANDRADE 607',
        url: 'https://ecopower.com.br/',
      },
      {
        nameParceiro: 'ELETROBIDU',
        cnpj: '76.25270001-53', // ESTA FALTANDO
        endereco: 'EST BENEDITO RODRIGUES CARDOSO',
        url: 'https://www.eletrobidu.com.br/',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1837',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
  {
    state: 'Tocantins',
    parceiros: [
      {
        nameParceiro: 'MOHS ENERGY',
        cnpj: '41.602.693/0001-70',
        endereco: 'AV JOAQUIM TEOTONIO SEGURADO, QD 9 LT 3 SL B2 13 BAIRRO PLANO DIRETOR SUL',
        url: 'https://www.instagram.com/mohs_energy?igsh=MXh5MDF0MWV1bTgzZA==',
      },
      {
        nameParceiro: 'DESCARBONIZE',
        cnpj: '81.106.957/0001-19',
        endereco: 'Av. Advogado H R Filho, 1839',
        url: 'https://descarbonizesolucoes.com.br/parceria/santander',
      },
    ],
  },
];
